import { MutOpt } from '@/app/api';
import { queryClient } from '@/lib/query-client';
import { createQueryKeys } from '@/lib/query-factory';
import { queryOptions } from '@tanstack/react-query';
import { toast } from 'sonner';
import * as api from './cache.api';

const keys = createQueryKeys('cache');

export const cacheQueries = {
  keys,
  entries: () =>
    queryOptions({
      queryKey: keys.list('entries'),
      queryFn: api.fetchCacheEntries,
    }),
  stats: () =>
    queryOptions({
      queryKey: keys.list('stats'),
      queryFn: api.fetchCacheStats,
    }),
  enabled: () =>
    queryOptions({
      queryKey: keys.detail('enabled'),
      queryFn: api.fetchCacheEnabled,
    }),
};

const invalidateAll = () =>
  queryClient.invalidateQueries({ queryKey: keys.all });

const onError = (message: string) => (error: Error) =>
  toast.error(message, { description: error.message });

export const cacheMutations = {
  setEnabled: (): MutOpt<typeof api.setCacheEnabled> => ({
    mutationFn: api.setCacheEnabled,
    onSuccess: (_, enabled) => {
      invalidateAll();
      toast.success(enabled ? 'Cache enabled' : 'Cache disabled');
    },
    onError: onError('Failed to switch the cache'),
  }),
  clear: (): MutOpt<typeof api.clearCache> => ({
    mutationFn: api.clearCache,
    onSuccess: () => {
      invalidateAll();
      toast.success('Cache cleared');
    },
    onError: onError('Failed to clear the cache'),
  }),
  resetStats: (): MutOpt<typeof api.resetCacheStats> => ({
    mutationFn: api.resetCacheStats,
    onSuccess: () => {
      invalidateAll();
      toast.success('Statistics reset');
    },
    onError: onError('Failed to reset the statistics'),
  }),
};
